'use strict';
/* COMPONENT - c.06.06 - location search */

export class LocationInput {

    constructor(element) {
        this.root = element;
        this.input = this.root.querySelector('input[type=text]');
        this.hiddenInput = this.root.querySelector('input[type=hidden]');
        this.hiddenLong = this.root.querySelector('input[name=location_long]');
        this.hiddenLat = this.root.querySelector('input[name=location_lat]');
        this.dropDown = this.root.querySelector('.drop-down');
        this.currentLocation = this.dropDown.querySelector('.current-loc a');
        this.error = this.root.querySelector('.error');
        this.selected = 0;
        this.listItems = this.dropDown.querySelectorAll('li');
        this.closeTimeout;
        this.autocomplete;
        this.placesService;
        this.accreditation = document.createElement('li');
            
        var accreditationImage = document.createElement('img');
        accreditationImage.setAttribute('style', 'float:right;');
        accreditationImage.setAttribute('src', 'https://developers.google.com/maps/documentation/images/powered_by_google_on_white.png')
        this.accreditation.appendChild(accreditationImage);

        this.bindEvents();
        
        if ('geolocation' in navigator !== true) {
            this.currentLocation.style.display = 'none';
        }
    }
    
    openDropDown() {
        clearTimeout(this.closeTimeout);
        this.root.classList.add('open');
        this.hideError();
    }
    
    closeDropDown() {
         this.closeTimeout = setTimeout(() => {
            this.root.classList.remove('open');
        }, 50);
    }
    
    showError(err) {
        this.root.classList.add('error');
        this.error.innerHTML = err;
        this.closeDropDown();
    }
    
    hideError() {
        this.root.classList.remove('error');
        this.error.innerHTML = '';
    }
    
    inputFocusHandler() {
        this.input.select();
        this.openDropDown();
    }
    
    inputBlurHandler() {
       this.closeDropDown();
    }
    
    inputKeyupHandler(event) {
        this.openDropDown();
        if (event.keyCode !== 40 && event.keyCode !== 38) {
            if (this.autocomplete && this.input.value.length > 0) {
                this.root.classList.contains('error-empty') ? this.root.classList.remove('error-empty') : '';
                this.autocomplete.getPlacePredictions({ input: this.input.value, componentRestrictions: {country: 'uk'}}, (results) => {
                    this.renderResults(results || []);
                    if (results) {
                        this.placesService.getDetails({placeId: results[0].place_id, fields: ['geometry' , 'formatted_address']} , (res) => {
                            this.setInputs(res.geometry.location.lng(), res.geometry.location.lat(), res.formatted_address);
                        });
                    } else {
                        this.setInputs('', '');
                    }
                    
                });
            } else {
                this.renderResults([]);
                this.setInputs('', '');
            }
        }
        this.hiddenInput.value = this.input.value;
    }
    
    inputKeydownHandler(event) {
        if (this.selected) {
            this.listItems[this.selected - 1].classList.remove('selected');
        }
        
        if (event.keyCode === 40 || event.keyCode === 38) {
            event.preventDefault();
            event.stopPropagation();
            
            if (event.keyCode === 40) {
                this.selected = this.selected += 1;
            } else if (event.keyCode === 38) {
                this.selected = this.selected -= 1;
            }

            if (this.selected <= 0) {
                this.selected = this.listItems.length;
            } else if (this.selected > this.listItems.length) {
                this.selected = 1;
            }
            
            this.listItems[this.selected - 1].classList.add('selected');
            
        } else if (event.keyCode === 13 && this.selected !== 0) {
            event.preventDefault();
            event.stopPropagation();
            
            this.listItems[this.selected - 1].querySelector('a').click();
            this.selected = 0;
        } else {
            this.selected = 0;
        }
    }
    
    renderResults(results) {
        let container = document.createElement('ul');
        
        container.appendChild(this.buildItem({description: 'Use my location'}, true));

        for (let i = 0; i < results.length; i += 1) {
            container.appendChild(this.buildItem(results[i]));
        }
        
        container.appendChild(this.accreditation);

        this.dropDown.innerHTML = '';
        this.dropDown.appendChild(container);
        
        this.listItems = this.dropDown.querySelectorAll('li');
    }
    
    buildItem(result, current) {
        let item = document.createElement('li'),
            a = document.createElement('a');
        
        if (result.matched_substrings) {
            let i, 
                offset = 0;

            for (i = 0; i < result.matched_substrings.length; i += 1) {
                result.description = result.description.substr(0, result.matched_substrings[i].offset + offset) + '<strong>' + result.description.substr(result.matched_substrings[i].offset + offset, result.matched_substrings[i].length) + '</strong>' +  result.description.substr(result.matched_substrings[i].offset + result.matched_substrings[i].length + offset);
                offset += 17;
            }
        }
        
        a.setAttribute('tabindex', -1);
        a.innerHTML = result.description;
        a.href = '';
        a.addEventListener('focus', this.openDropDown.bind(this));
        if (current) {
            item.classList.add('current-loc');
            a.addEventListener('click', this.currentLocationClickHandler.bind(this));
        } else {
            a.addEventListener('click', this.locationClickHandler.bind(this, result));
        }
        
        item.appendChild(a);
        
        return item;
    }
    
    locationClickHandler(result, event) {
        event.preventDefault();
        this.placesService.getDetails({placeId: result.place_id, fields: ['geometry' , 'formatted_address']} , (res) => {
            this.setInputs(res.geometry.location.lng(), res.geometry.location.lat(),  res.formatted_address, true);
        });
    }
    
    currentLocationClickHandler(event) {
        event.preventDefault();
        
        navigator.geolocation.getCurrentPosition((position) => {
            this.setInputs(position.coords.longitude, position.coords.latitude, 'Current location', true);
        }, (err) => {
            this.showError('Unable to use current location');
        });
    }
    
    setInputs(long, lat, desc, update) {
        this.hiddenLong.value = long;
        this.hiddenLat.value = lat;
        if (desc) {
            this.hiddenInput.value = desc;
            if (update) {
                this.closeDropDown();
                this.input.value = desc;
            }
        }
    }
    
    initAutocomplete() {
        this.autocomplete = new window.google.maps.places.AutocompleteService();
        this.placesService =  new window.google.maps.places.PlacesService(window.document.createElement('div'));
        this.renderResults([]);
    }
    
    bindEvents() {
        this.input.addEventListener('focus', this.inputFocusHandler.bind(this));
        this.input.addEventListener('blur', this.inputBlurHandler.bind(this));
        this.input.addEventListener('keyup', this.inputKeyupHandler.bind(this));
        this.input.addEventListener('keydown', this.inputKeydownHandler.bind(this));
        
        this.currentLocation.addEventListener('focus', this.openDropDown.bind(this));
        this.currentLocation.addEventListener('blur', this.closeDropDown.bind(this));
        
        this.currentLocation.addEventListener('click', this.currentLocationClickHandler.bind(this));
    }
}

export default class LocationSearch {

    constructor(element) {
        this.root = element;
        this.form = this.root.getElementsByTagName('form')[0];
        this.filterButton = this.root.querySelector('.location-search-button').getElementsByTagName('button')[0];
        this.filterContainer = this.root.querySelector('.location-search-fields');
        this.buttonText = this.filterButton.getAttribute('data-text');
        this.buttonFilterText = this.filterButton.getAttribute('data-filter-text');
        this.windowWidth = document.body.clientWidth;
        this.locationInput = false;
        this.sortOption = this.root.querySelector('.location-search-sort-options a');
        this.resizeEvent;
        this.resizeListener();
        this.bindEvents();
        this.changeButtonVal();
        
        if (this.root.querySelector('.location-input')) {
            this.locationInput = new LocationInput(this.root.querySelector('.location-input'));
        }
        
        if (!this.filterContainer.classList.contains('location-search-fields--hidden')) {
            this.filterContainer.classList.add('location-search-fields--overflow');
        }
    }

    setSortByCookie(value) {
        document.cookie = 'event-search-sort-option=' + value;
    }

    filterClick(ev) {
        ev.preventDefault();
        if (this.windowWidth <= 768 && this.filterContainer.classList.contains('location-search-fields--hidden')) {
            this.filterContainer.classList.remove('location-search-fields--hidden');
            this.filterButton.getElementsByTagName('span')[1].innerHTML = this.buttonText;
            setTimeout(() => {
                this.filterContainer.classList.add('location-search-fields--overflow');
            }, 700);
        } else if (!this.root.querySelector('input[name=suppress_validation]') && document.querySelector('.location-input')) {
            let g_lat = this.filterContainer.querySelector('input[name=location_lat]').getAttribute('value');
            let g_long = this.filterContainer.querySelector('input[name=location_long]').getAttribute('value');

            if (g_lat && g_long) {
                this.form.submit();
            } else {
                !this.locationInput.root.classList.contains('error-empty') ? this.locationInput.root.classList.add('error-empty') : '';
            }
        } else {
            this.form.submit();
        }
    }

    changeButtonVal() {
        if (this.windowWidth <= 768 && this.filterContainer.classList.contains('location-search-fields--hidden')) {
            this.filterButton.getElementsByTagName('span')[1].innerHTML = this.buttonFilterText;
        } else {
            this.filterButton.getElementsByTagName('span')[1].innerHTML = this.buttonText;
        }
    }

    resizeTimer() {
        clearTimeout(this.resizeEvent);
        this.resizeEvent = setTimeout(this.updateWidth.bind(this), 100);
    }

    updateWidth() {
        this.windowWidth = document.body.clientWidth;
        this.changeButtonVal();
    }

    resizeListener() {
        window.addEventListener('resize', this.resizeTimer.bind(this));
    }

    bindEvents() {
        this.form.addEventListener('submit', this.filterClick.bind(this));
        if (this.sortOption){
            this.sortOption.addEventListener('click', this.setSortByCookie.bind(this, this.sortOption.innerText.toLowerCase()));
        }
    }
}

if (document.querySelector('.location-search')) {
    let searches = document.querySelectorAll('.location-search'),
        gScript = document.createElement('script'),
        locationObjects = [];
    
    for (let i = 0; i < searches.length; i += 1) {
        locationObjects.push(new LocationSearch(searches[i]));
    }
    
    window.gMaps = function () {
        for (let i = 0; i < locationObjects.length; i += 1) {
            if (locationObjects[i].locationInput) {
                locationObjects[i].locationInput.initAutocomplete();
            }
        }
    };
    
    if (document.querySelector('.location-input')) {
        gScript.type = 'text/javascript';
        gScript.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyDhEL8aXJXU1UN_cnmzDU3d3nAv-gvvyEk&libraries=places&callback=gMaps';
        document.body.appendChild(gScript);
    }
}
